import type { DisplaySize } from '../../utils/displaySize';

interface ISampleLine {
  x: number;
  y: number;
  width: number;
}

interface ISampleText {
  glyphs: string;
  lines: ISampleLine[];
}

const SAMPLE_TEXT_BY_SIZE: Record<DisplaySize, ISampleText> = {
  small: {
    glyphs:
      'M49.6428 61.2206H45.4988L44.8132 63.2031H42.6219L46.3634 52.7837H48.7931L52.5346 63.2031H50.3285L49.6428 61.2206ZM49.0763 59.5511L47.5708 55.1985L46.0653 59.5511H49.0763ZM53.3965 59.0443C53.3965 58.2095 53.5604 57.4692 53.8884 56.8232C54.2263 56.1773 54.6784 55.6804 55.2449 55.3326C55.8212 54.9848 56.4622 54.8109 57.1678 54.8109C57.7839 54.8109 58.3205 54.9351 58.7776 55.1836C59.2447 55.432 59.6174 55.745 59.8956 56.1227V54.9451H61.9974V63.2031H59.8956V61.9957C59.6273 62.3833 59.2546 62.7062 58.7776 62.9646C58.3106 63.2131 57.769 63.3373 57.1529 63.3373C56.4572 63.3373 55.8212 63.1584 55.2449 62.8007C54.6784 62.4429 54.2263 61.9411 53.8884 61.2951C53.5604 60.6392 53.3965 59.889 53.3965 59.0443ZM59.8956 59.0741C59.8956 58.5673 59.7962 58.135 59.5975 57.7772C59.3987 57.4096 59.1304 57.1313 58.7925 56.9425C58.4547 56.7437 58.0919 56.6444 57.7044 56.6444C57.3168 56.6444 56.9591 56.7388 56.6311 56.9276C56.3032 57.1164 56.0349 57.3947 55.8262 57.7623C55.6274 58.1201 55.5281 58.5474 55.5281 59.0443C55.5281 59.5412 55.6274 59.9784 55.8262 60.356C56.0349 60.7237 56.3032 61.0069 56.6311 61.2057C56.969 61.4044 57.3268 61.5038 57.7044 61.5038C58.0919 61.5038 58.4547 61.4094 58.7925 61.2206C59.1304 61.0218 59.3987 60.7436 59.5975 60.3858C59.7962 60.0182 59.8956 59.5809 59.8956 59.0741Z',
    lines: [
      { x: 36.4375, y: 77.8438, width: 33.125 },
      { x: 39.75, y: 85.2969, width: 26.5 },
    ],
  },
  normal: {
    glyphs:
      'M48.7998 62.8332H43.2745L42.3603 65.4766H39.4386L44.4273 51.5839H47.6669L52.6555 65.4766H49.714L48.7998 62.8332ZM48.0445 60.6072L46.0371 54.8037L44.0297 60.6072H48.0445ZM53.8047 59.9314C53.8047 58.8184 54.0233 57.8313 54.4606 56.9701C54.9111 56.1088 55.5139 55.4463 56.2692 54.9826C57.0377 54.5188 57.8923 54.2869 58.8331 54.2869C59.6546 54.2869 60.3701 54.4526 60.9796 54.7838C61.6023 55.1151 62.0992 55.5324 62.4702 56.0359V54.4658H65.2726V65.4766H62.4702V63.8667C62.1124 64.3834 61.6156 64.8141 60.9796 65.1586C60.3568 65.4898 59.6347 65.6554 58.8132 65.6554C57.8857 65.6554 57.0377 65.4169 56.2692 64.9399C55.5139 64.4629 54.9111 63.7938 54.4606 62.9326C54.0233 62.0581 53.8047 61.0577 53.8047 59.9314ZM62.4702 59.9712C62.4702 59.2954 62.3377 58.7191 62.0727 58.2421C61.8077 57.7518 61.4499 57.3808 60.9994 57.1291C60.5489 56.8641 60.0653 56.7316 59.5486 56.7316C59.0318 56.7316 58.5548 56.8574 58.1176 57.1092C57.6803 57.3609 57.3226 57.7319 57.0443 58.2222C56.7793 58.6992 56.6468 59.2689 56.6468 59.9314C56.6468 60.5939 56.7793 61.1769 57.0443 61.6804C57.3226 62.1707 57.6803 62.5483 58.1176 62.8133C58.5681 63.0783 59.0451 63.2108 59.5486 63.2108C60.0653 63.2108 60.5489 63.0849 60.9994 62.8332C61.4499 62.5682 61.8077 62.1972 62.0727 61.7202C62.3377 61.2299 62.4702 60.6469 62.4702 59.9712Z',
    lines: [
      { x: 31.4688, y: 81.5703, width: 43.0625 },
      { x: 35.6094, y: 89.0234, width: 34.7812 },
    ],
  },
  large: {
    glyphs:
      'M47.5377 63.9833H40.1707L38.9517 67.5078H35.0562L41.7077 48.9843H46.0272L52.6787 67.5078H48.7567L47.5377 63.9833ZM46.5307 61.0153L43.8542 53.2773L41.1777 61.0153H46.5307ZM54.2109 60.1143C54.2109 58.6303 54.5024 57.3141 55.0854 56.1658C55.6861 55.0175 56.4899 54.1341 57.4969 53.5158C58.5216 52.8975 59.6611 52.5883 60.9154 52.5883C62.0108 52.5883 62.9648 52.8091 63.7774 53.2508C64.6078 53.6925 65.2703 54.249 65.7649 54.9203V52.8268H69.5014V67.5078H65.7649V65.3613C65.2879 66.0503 64.6254 66.6245 63.7774 67.0838C62.9471 67.5255 61.9843 67.7463 60.8889 67.7463C59.6523 67.7463 58.5216 67.4283 57.4969 66.7923C56.4899 66.1563 55.6861 65.2641 55.0854 64.1158C54.5024 62.9498 54.2109 61.616 54.2109 60.1143ZM65.7649 60.1673C65.7649 59.2663 65.5883 58.4978 65.2349 57.8618C64.8816 57.2081 64.4046 56.7135 63.8039 56.3778C63.2033 56.0245 62.5584 55.8478 61.8694 55.8478C61.1804 55.8478 60.5444 56.0156 59.9614 56.3513C59.3784 56.687 58.9014 57.1816 58.5304 57.8353C58.1771 58.4713 58.0004 59.231 58.0004 60.1143C58.0004 60.9976 58.1771 61.775 58.5304 62.4463C58.9014 63.1 59.3784 63.6035 59.9614 63.9568C60.5621 64.3101 61.1981 64.4868 61.8694 64.4868C62.5584 64.4868 63.2033 64.319 63.8039 63.9833C64.4046 63.63 64.8816 63.1353 65.2349 62.4993C65.5883 61.8456 65.7649 61.0683 65.7649 60.1673Z',
    lines: [
      { x: 27.3281, y: 86.5391, width: 51.3438 },
      { x: 32.2969, y: 93.9922, width: 41.4062 },
    ],
  },
};

export function DisplaySizePreview({
  size,
  className = '',
}: Readonly<{ size: DisplaySize; className?: string }>) {
  const { glyphs, lines } = SAMPLE_TEXT_BY_SIZE[size];

  return (
    <span className={`icon ${className}`}>
      <svg
        width="106"
        height="131"
        viewBox="0 0 106 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="selection-ring"
          x="0.828125"
          y="0.828125"
          width="104.344"
          height="129.188"
          rx="14.0781"
          stroke="var(--clr-general-primary)"
          strokeWidth="1.65625"
        />
        <rect
          x="4.96875"
          y="4.96875"
          width="96.0625"
          height="120.906"
          rx="10.7656"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
          strokeWidth="1.65625"
        />
        <rect
          x="14.0781"
          y="14.0781"
          width="36.4375"
          height="4.96875"
          rx="2.48438"
          fill="var(--clr-icon-color)"
        />
        <circle cx="89.4376" cy="16.5621" r="2.65" fill="var(--clr-icon-color)" />
        <rect
          x="12.4219"
          y="28.9844"
          width="81.1562"
          height="1.24219"
          fill="var(--clr-border-grey-100)"
        />
        <path d={glyphs} fill="var(--clr-title)" />
        {lines.map((line) => (
          <rect
            key={line.y}
            x={line.x}
            y={line.y}
            width={line.width}
            height="3.3125"
            rx="1.65625"
            fill="var(--clr-icon-color)"
          />
        ))}
        <rect
          x="14.0781"
          y="103.516"
          width="77.8438"
          height="13.25"
          rx="6.625"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
